const config = {
    TOKEN_SECRET: "tokenultrasecreto"
};

export default config;